import { useIntl } from 'react-intl'
import SolidBuildingIcon from 'LuxKit/Icons/solid/SolidBuildingIcon'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import { TimelineEndNode, TimelineNode } from 'components/Common/CancellationPolicies/Flash/CancellationPolicyTimelineComponents'
import useRebrandSuccessDarkColour from 'hooks/useRebrandSuccessDarkColour'

interface Props {
  /** The free-cancellation deadline as the inline label shows it. */
  deadline: string
  /** lib-refunds policy description: the first line restates the deadline, the rest are the fees after it. */
  policyDescriptions: Array<string | undefined>
}

function CancellationPolicyTimeline({ deadline, policyDescriptions }: Props) {
  const intl = useIntl()
  const fullRefundColour = useRebrandSuccessDarkColour()

  const fullRefundPeriodLabel = intl.formatMessage(
    {
      id: 'l3pEXYwwkXfvG_HOiItm',
      defaultMessage: 'Up to {date}',
    },
    { date: deadline },
  )

  return (
    <Group direction="vertical">
      <TimelineNode label={fullRefundPeriodLabel}>
        <BodyText variant="medium" weight="bold" colour={fullRefundColour}>
          {intl.formatMessage({
            id: 'r9azUL0QDMZGX5C30Pob',
            defaultMessage: 'Full refund',
          })}
        </BodyText>
        <BodyText variant="medium" as="p">
          {intl.formatMessage({
            id: 'V9m86aTlRn2tOX5EbgwB',
            defaultMessage: 'Cancel for free and get a full refund to your original payment method.',
          })}
        </BodyText>
      </TimelineNode>

      <TimelineNode label={deadline}>
        <BodyText variant="medium" weight="bold">
          {intl.formatMessage({
            id: '3Vg6VMyAbTjQ1azpGcNA',
            defaultMessage: 'Cancellation fees apply',
          })}
        </BodyText>
        {policyDescriptions.slice(1).map((line, index) => <BodyText variant="medium" as="p" key={index}>{line}</BodyText>)}
      </TimelineNode>

      <TimelineEndNode
        icon={SolidBuildingIcon}
        label={intl.formatMessage({
          id: '_LMHoUEIwBdxs6JfijFx',
          defaultMessage: 'Check-in',
        })}
      />
    </Group>
  )
}

export default CancellationPolicyTimeline
